import { Wifi, UploadCloud, Clock, Thermometer, Monitor, BatteryCharging, Activity, RotateCw, Cpu, Server, ToggleRight, Settings } from 'lucide-react';

export const getDiagnosticItems = (processedData) => {
  // Helper to map specifically defined "positive" status strings
  const mapStatus = (val, target) => {
    if (!val) return "False";
    const cleanVal = val.toString().trim().toLowerCase();
    
    // Default positive keywords for general mapping
    const positiveKeywords = target 
      ? [target.toLowerCase()] 
      : ["alive", "on", "connected", "reachable", "running", "ok", "internet is connected", "plc is reachable"];
      
    // Returns "True" if the status matches or contains the specific healthy keyword
    return positiveKeywords.some(keyword => cleanVal.includes(keyword)) ? "True" : "False";
  };

  const user = JSON.parse(localStorage.getItem("user"));
  const userRole = user?.role || "";

  const checkDeviceArrayStatus = (arr, statusKey) => {
    if (!arr || arr.length === 0) return "False";
    return arr.every(item => 
      item[statusKey]?.toLowerCase() === "on" || item[statusKey]?.toLowerCase() === "running"
    ) ? "True" : "False";
  };

  // Safe data extraction based on user's API structure
  const internetRaw = processedData?.internetConnectivityStatus?.[0]?.InternetStatus;
  const applicationRaw = processedData?.HahwApplicationStatus?.[0]?.HahwStatus;
  const restartRaw = processedData?.restartStatus?.[0]?.RestartStatus;
  const systemRaw = processedData?.systemStatus?.[0]?.SysStatus;
  const jetsonRaw = processedData?.jetsonStatus?.[0]?.JetsonStatus;
  const plcRaw = processedData?.plcStatus?.[0]?.PlcStatus;
  const proxyCRaw = processedData?.proxyStatus?.[0]?.c_proxy_status;
  const proxySRaw = processedData?.proxyStatus?.[0]?.s_proxy_status;
  const uploaderRaw = processedData?.UploaderApplicationStatus?.[0]?.UploaderStatus;

  // Temperature Sensor Logic: Must all Sensors be "CONNECTED"
  const tempSensData = processedData?.TempSensStatus?.[0] || {};
  const numberOfTempSensors = parseInt(processedData?.numberOfTempSensors) || 6;
  let tempSensorStatus = 'False';
  if (tempSensData) {           
    let allConnected = true;
    for (let i = 1; i <= numberOfTempSensors; i++) {
      const sensorValue = tempSensData[`T${i}`];
      if (!sensorValue || sensorValue.toString().toUpperCase() !== "CONNECTED") {
        allConnected = false;
        break;
      }
    }
    tempSensorStatus = allConnected ? 'True' : 'False';
  }

  const diagnosticlItems = [
    {
      id: 'Internetconnectivity',
      icon: Wifi,
      title: 'Internet Connectivity',
      description: 'Represents wireless internet connectivity.',
      status: mapStatus(internetRaw, "Internet is connected"),
    },
    {
      id: 'Application-status',
      icon: Activity,
      title: 'HABD Application Status',
      description: 'Displays a waveform-like line showing the status of an application.',
      status: mapStatus(applicationRaw, "running"),
    },
    {
      id: 'System-Restartd',
      icon: RotateCw,
      title: 'System Restart Status',
      description: 'A circular arrow pointing clockwise; typically symbolizes restarting a system.',
      status: restartRaw ? "True" : "NULL",
    },
    {
      id: 'PC status',
      icon: Monitor,
      title: 'PC System Status',
      description: 'Displays the operational status of the connected PC.',
      // Green if either systemStatus is "Alive" or jetsonStatus is "ON"
      status: (mapStatus(systemRaw, "Alive") === "True" || mapStatus(jetsonRaw, "ON") === "True") ? "True" : "False",
    },
    {
      id: 'Temperature sensor',
      icon: Thermometer,
      title: 'Temperature sensor Status',
      description: 'Monitors and reports real-time temperature readings.',
      status: tempSensorStatus,
    },
  ];

  if (userRole === "Super Admin") {
    diagnosticlItems.push({
      id: "Maintenance", // Must match ContentCard.js condition
      icon: Settings,               // Using the imported Settings icon
      title: "Maintenance",
      description: "Represents Maintenance Management.",
      status: processedData?.internetConnectivityStatus?.[0]?.InternetStatus || "False",
    });
  }

  const diagnosticRItems = [
    {
      id: 'PLC-Status',
      icon: Cpu,
      title: 'Controller Status',
      description: 'Represents a microprocessor or logic controller for PLC-related status or operations.',
      status: mapStatus(plcRaw, "PLC is reachable"),
    },
    {
      id: 'Proxy-Status',
      icon: Server,
      title: 'Proximity Sensor',
      description: 'Depicts stacked server racks; represents server-based systems like proxies.',
      // Green only if both S and C proxy are "ON"
      status: (mapStatus(proxyCRaw, "ON") === "True" && mapStatus(proxySRaw, "ON") === "True") ? "True" : "False",
    },
    {
      id: 'Uploader-Status',
      icon: UploadCloud,
      title: 'Uploader Status',
      description: 'Indicates whether the data uploader is active or inactive.',
      status: mapStatus(uploaderRaw, "running"),
    },
    {
      id: 'ups',
      icon: BatteryCharging,
      title: 'Power Backup Status',
      description: 'Displays the current status of the Uninterruptible Power Supply.',
      status: 'True',
    },
    {
      id: 'network switch',
      icon: ToggleRight,
      title: 'network switch',
      description: 'Indicates the status of the network switch connection.',
      status: 'True',
    },
  ];

  return { diagnosticlItems, diagnosticRItems };
};